import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { formatPrice } from 'utils/string-manipulation/format-price';
import { TFooterField } from 'newelements/_Betslip/hooks/generateFieldsMapping/types';
import { FREE_BET_AMOUNT_SELECTOR_PORTAL_ID } from 'newelements/_Betslip/utils/constants/shared';
import store from 'store';

export const getTestIdAttribute = (v: string): TFooterField['attributes'] => ({
  'data-testid': v.toLowerCase().replace(' ', '-')
});

export const generateSimpleId = (() => {
  let prevId = 0;

  return () => ++prevId;
})();

export const getCustomFieldPortalId = (
  prefix: string | number,
  postfix: string
) => `${prefix}-${postfix}`;

export const getFreeBetPortalId = (
  eventId: string | number,
  betslipId: string
) =>
  getCustomFieldPortalId(
    eventId,
    `${FREE_BET_AMOUNT_SELECTOR_PORTAL_ID}-${betslipId}`
  );

export const addSeparatorAndCut = (amount: number | string) => {
  return formatPrice(
    amount,
    SpringConfigs.PRICE_SEPARATOR,
    SpringConfigs.HIDE_TRAILING_ZEROES,
    store.getState().appData.rounding
  );
};
